import classes from "../../utils/classes";
import { TableFlowProps } from "./types";
import style from "./style/TableFlow.module.scss";
import { ReactComponent as TableFlowLogoShort } from "../../assets/tableflow-icon.svg";
import { ReactComponent as TableFlowLogoColor } from "../../assets/tableflow-logo-color.svg";
import { ReactComponent as TableFlowLogo } from "../../assets/tableflow-logo.svg";

export default function TableFlow({ color, size = "normal", short = false }: TableFlowProps) {
  const className = classes(["tableflow", style.tableflow, style[size]]);

  let logo;

  if (color) {
    if (short) {
      logo = <TableFlowLogoShort />;
    } else {
      logo = <TableFlowLogoColor />;
    }
  } else {
    if (short) {
      logo = <TableFlowLogoShort />;
    } else {
      logo = <TableFlowLogo />;
    }
  }

  return <div className={className}>{logo}</div>;
}
